var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15183",
    "data-name": "Group 15183",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.006,
    height: 50.222,
    viewBox: "0 0 122.006 50.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M169.855,142.565a7.281,7.281,0,0,1,7.374-2.393l3.683-14.524a22.284,22.284,0,0,0-22.562,7.322Z",
    transform: "translate(-153.582 -118.531)",
    fill: "#62af31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M236.9,212.043a7.287,7.287,0,0,1-1.815,2.62l7.807,8.476a18.832,18.832,0,0,0,4.692-6.769Z",
    transform: "translate(-208.298 -180.62)",
    fill: "#00aaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M231.235,153.495l-3.216,7.4a7.272,7.272,0,0,1,4.193,8.28l7.866,1.784a15.334,15.334,0,0,0-8.843-17.462Z",
    transform: "translate(-203.26 -138.872)",
    fill: "#bfce18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M209.481,223.7a7.272,7.272,0,0,1-6.374.8l-2.631,7.625a15.333,15.333,0,0,0,13.443-1.693Z",
    transform: "translate(-183.62 -188.928)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M172.514,196.654l3.825-7.1a7.275,7.275,0,0,1-2.814-10.1l-6.946-4.1a15.341,15.341,0,0,0,5.935,21.309Z",
    transform: "translate(-157.929 -154.452)",
    fill: "#f77e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(21.51 45.222)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.947,
    cy: 2.947,
    r: 2.947,
    transform: "translate(0 31.032)",
    fill: "#f77e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.844,
    cy: 1.844,
    r: 1.844,
    transform: "translate(38.131 38.985)",
    fill: "#00aaef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.974,
    cy: 2.974,
    r: 2.974,
    transform: "translate(35.884 16.075)",
    fill: "#bfce18"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.305,
    cy: 3.305,
    r: 3.305,
    transform: "translate(10.059)",
    fill: "#62af31"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(51.123 14.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M332.825,153.847H319.9v29.309h2.252a3.779,3.779,0,0,0,3.78-3.78v-6.523h6.9a9.5,9.5,0,0,0,9.5-9.5h0A9.5,9.5,0,0,0,332.825,153.847Zm3.411,9.49a4.589,4.589,0,0,1-4.589,4.589h-5.719v-9.178h5.719a4.589,4.589,0,0,1,4.589,4.589Z",
    transform: "translate(-319.898 -153.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M426.165,154.969v-1.122H406.559v29.309h19.606v-1.122a3.779,3.779,0,0,0-3.779-3.779h-9.777v-7.3h11.613v-4.9H412.609v-7.3h9.777A3.78,3.78,0,0,0,426.165,154.969Z",
    transform: "translate(-381.692 -153.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M501.4,157.275V172.9l-10.67-17.582a3.78,3.78,0,0,0-3.231-1.819h-3.947V182.9h2.3a3.779,3.779,0,0,0,3.779-3.779V163.5L500.3,181.086a3.779,3.779,0,0,0,3.231,1.818h3.947v-29.41h-2.295A3.78,3.78,0,0,0,501.4,157.275Z",
    transform: "translate(-436.596 -153.495)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWhite);
export default __webpack_public_path__ + "static/media/PENWhite.852e0d75bd687babf18fdeaf91b8ec0b.svg";
export { ForwardRef as ReactComponent };